import GlobalStore from "../store/globalStore";

export const getNriAccountType = (getNriAccountLabel: boolean): "NRE" | "NRO" | "" => {
  const entitySubType = GlobalStore.entitySubType?.toUpperCase() ?? "";
  if (getNriAccountLabel) {
    if (entitySubType.includes("NRE")) return "NRE";
    if (entitySubType.includes("NRO")) return "NRO";
  }

  return "";
};